import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { eur } from "@/components/common";

function useCountdown(endDate) {
  const [left, setLeft] = useState("");
  useEffect(() => {
    if (!endDate) return undefined;
    const end = new Date(`${endDate}T23:59:59`);
    const tick = () => {
      const ms = end - new Date();
      if (ms <= 0) { setLeft(""); return; }
      const d = Math.floor(ms / 86400000);
      const h = Math.floor((ms % 86400000) / 3600000);
      const m = Math.floor((ms % 3600000) / 60000);
      setLeft(d > 0 ? `${d} giorni, ${h} ore e ${m} minuti` : `${h} ore e ${m} minuti`);
    };
    tick();
    const t = setInterval(tick, 30000);
    return () => clearInterval(t);
  }, [endDate]);
  return left;
}

export default function CampaignBanner({ testid = "campaign-banner" }) {
  const [camp, setCamp] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api.get("/campaigns/active")
      .then((r) => { setCamp(r.data || null); setLoaded(true); })
      .catch(() => setLoaded(true));
  }, []);

  const left = useCountdown(camp?.end_date);

  if (!loaded || !camp) return null;

  return (
    <section className="max-w-6xl mx-auto px-4 sm:px-6 py-10" data-testid={testid}>
      <div className="rounded-3xl overflow-hidden border border-[#d8c9a3] bg-[#faf6ec] grid md:grid-cols-2">
        <img
          src={camp.image}
          alt={camp.name}
          className="w-full h-64 md:h-full object-cover object-center"
          data-testid={`${testid}-image`}
        />
        <div className="p-8 flex flex-col justify-center">
          <p className="eyebrow mb-2">{camp.name}</p>
          <h2 className="font-serif text-3xl sm:text-4xl text-navy mb-3">{camp.title}</h2>
          <p className="text-body text-sm sm:text-base mb-4">{camp.subtitle}</p>
          <p className="font-serif text-5xl text-[#8a6d2f] leading-none mb-2" data-testid={`${testid}-price`}>{eur(camp.price)}</p>
          <p className="text-sm font-semibold text-navy">{camp.product_name}</p>
          <p className="text-sm text-muted-soft mb-2">{camp.delivery_note}</p>
          <p className="text-xs font-semibold text-[#2f5d3e] mb-5 leading-relaxed" data-testid={`${testid}-credit-note`}>
            Se attivi un abbonamento entro 10 giorni, l'intero importo dell'offerta ti verrà riconosciuto come credito sull'abbonamento (una sola volta per account).
          </p>
          <Link to={camp.cta_link || "/campagna"} data-testid={`${testid}-cta`} className="btn-primary w-full sm:w-auto text-center">
            {camp.cta_label}
          </Link>
          <p className="text-xs text-muted-soft mt-3" data-testid={`${testid}-countdown`}>
            Offerta valida fino al {new Date(`${camp.end_date}T12:00:00`).toLocaleDateString("it-IT", { day: "numeric", month: "long" })}
            {left ? ` — termina tra ${left}` : ""}
          </p>
        </div>
      </div>
    </section>
  );
}
